export default "__VITE_ASSET__BK9Q8xd1__"